import {useEffect, useRef, useState} from "react";
import {Interpolation, Theme} from "@emotion/react";

import {useUserDevice} from "@pg-mono/user-device";
import {OfferType} from "@pg-rp/common-types";

import {FilterFooter} from "../../../search/components/filters/SearchFiltersFooter";
import {FloorChoicesSwitch} from "../../../search/components/FloorChoicesSwitch";
import {getFilterAreaTestId} from "../../../search/utils/filter_area_test_id";
import {getFloorChoiceLabel} from "../../../search/utils/get_label";
import {
    HitOfferModalFiltersParams,
    trackFilterApply,
    trackFilterClear,
    trackFilterOpenForCategory,
    trackFilterRemove
} from "../../tracking/hit_offer_modal_filters";
import {FakeSelectWithModal} from "./FakeSelectWithModal";

interface IProps {
    id: string;
    initialValue?: IFilterValue;
    rightDropdown?: boolean;
    onConfirm?: (value: IFilterValue) => void;
    handleClear?: () => void;
    aplaCss?: Interpolation<Theme>;
    labelRenderer?: (value?: IFilterValue) => Parameters<typeof FakeSelectWithModal>[0]["label"];
    onDropdownOpen?: () => void;
    onDropdownClose?: () => void;
    className?: string;
    offerType?: OfferType;
    trackingParams?: HitOfferModalFiltersParams;
}

type IFilterValue = number[];
const emptyValue: IFilterValue = [];
const name = "floors";

export function FloorFilter(props: IProps) {
    const {isMobile} = useUserDevice();

    const {
        id,
        initialValue,
        onConfirm,
        handleClear,
        rightDropdown,
        className,
        offerType,
        aplaCss,
        labelRenderer,
        onDropdownClose,
        onDropdownOpen,
        trackingParams
    } = props;

    const [value, setValue] = useState<IFilterValue>(initialValue ? initialValue : emptyValue);
    const isFirstRender = useRef(true);
    const prevOfferType = useRef(offerType);

    const handlers = {
        confirm: (values: IFilterValue) => {
            if (onConfirm) {
                onConfirm(values);
            }

            if (trackingParams?.eventName && !isMobile) {
                trackFilterApply({
                    eventName: trackingParams.eventName,
                    filterType: "floor",
                    value: values,
                    offerType
                });
            }
        },
        clear: () => {
            setValue(emptyValue);

            if (handleClear) {
                handleClear();
            }
        },
        dropdownOpen: () => {
            if (onDropdownOpen) {
                onDropdownOpen();
            }

            if (!isMobile && trackingParams?.eventName) {
                trackFilterOpenForCategory({filterCategory: "Piętra", eventName: trackingParams.eventName});
            }
        }
    };

    // Sync value with initialValue when it changes (e.g., when navigating between offers)
    useEffect(() => {
        if (!isFirstRender.current) {
            setValue(initialValue ? initialValue : emptyValue);
        }
    }, [initialValue]);

    // Clear floor filter when house filter is changed otherwise we will show house filter for flat or opposite
    // Skip on first render to preserve initialValue
    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            prevOfferType.current = offerType;
            return;
        }

        // Only clear if offerType actually changed
        if (prevOfferType.current !== offerType) {
            setValue(emptyValue);

            if (handleClear) {
                handleClear();
            }
            prevOfferType.current = offerType;
        }
    }, [offerType]);

    return (
        <FakeSelectWithModal
            clearAriaLabel="Wyczyść filtr Piętra"
            rightDropdown={rightDropdown}
            aplaCss={aplaCss}
            onDropdownOpen={handlers.dropdownOpen}
            onDropdownClose={onDropdownClose}
            label={labelRenderer ? labelRenderer(value) : getFloorChoiceLabel(value, offerType)}
            isEmpty={value.length === 0}
            onClear={() => {
                if (trackingParams?.eventName && !isMobile) {
                    trackFilterRemove({
                        eventName: trackingParams.eventName,
                        filterType: "floor",
                        value,
                        offerType
                    });
                }
                handlers.clear();
            }}
            className={className}
        >
            {({close}) => (
                <>
                    <div data-testid={getFilterAreaTestId(offerType === OfferType.HOUSE ? "house_storeys" : "floor_choices")}>
                        <FloorChoicesSwitch
                            offerType={offerType}
                            name={name}
                            id={id}
                            value={value}
                            onChange={(_, value) => {
                                setValue(value);
                            }}
                        />
                    </div>

                    <FilterFooter
                        onCancel={() => {
                            if (trackingParams?.eventName && !isMobile) {
                                trackFilterClear({
                                    eventName: trackingParams.eventName,
                                    filterType: "floor",
                                    value,
                                    offerType
                                });
                            }
                            handlers.clear();
                            close();
                        }}
                        onSave={() => {
                            handlers.confirm(value);
                            close();
                        }}
                    />
                </>
            )}
        </FakeSelectWithModal>
    );
}
import {useEffect, useRef, useState} from "react";
import {Interpolation, Theme} from "@emotion/react";

import {useUserDevice} from "@pg-mono/user-device";
import {OfferType} from "@pg-rp/common-types";

import {FilterFooter} from "../../../search/components/filters/SearchFiltersFooter";
import {FloorChoicesSwitch} from "../../../search/components/FloorChoicesSwitch";
import {getFilterAreaTestId} from "../../../search/utils/filter_area_test_id";
import {getFloorChoiceLabel} from "../../../search/utils/get_label";
import {
    HitOfferModalFiltersParams,
    trackFilterApply,
    trackFilterClear,
    trackFilterOpenForCategory,
    trackFilterRemove
} from "../../tracking/hit_offer_modal_filters";
import {FakeSelectWithModal} from "./FakeSelectWithModal";

interface IProps {
    id: string;
    initialValue?: IFilterValue;
    rightDropdown?: boolean;
    onConfirm?: (value: IFilterValue) => void;
    handleClear?: () => void;
    aplaCss?: Interpolation<Theme>;
    labelRenderer?: (value?: IFilterValue) => Parameters<typeof FakeSelectWithModal>[0]["label"];
    onDropdownOpen?: () => void;
    onDropdownClose?: () => void;
    className?: string;
    offerType?: OfferType;
    trackingParams?: HitOfferModalFiltersParams;
}

type IFilterValue = number[];
const emptyValue: IFilterValue = [];
const name = "floors";

export function FloorFilter(props: IProps) {
    const {isMobile} = useUserDevice();

    const {
        id,
        initialValue,
        onConfirm,
        handleClear,
        rightDropdown,
        className,
        offerType,
        aplaCss,
        labelRenderer,
        onDropdownClose,
        onDropdownOpen,
        trackingParams
    } = props;

    const [value, setValue] = useState<IFilterValue>(initialValue ? initialValue : emptyValue);
    const isFirstRender = useRef(true);
    const prevOfferType = useRef(offerType);

    const handlers = {
        confirm: (values: IFilterValue) => {
            if (onConfirm) {
                onConfirm(values);
            }

            if (trackingParams?.eventName && !isMobile) {
                trackFilterApply({
                    eventName: trackingParams.eventName,
                    filterType: "floor",
                    value: values,
                    offerType
                });
            }
        },
        clear: () => {
            setValue(emptyValue);

            if (handleClear) {
                handleClear();
            }
        },
        dropdownOpen: () => {
            if (onDropdownOpen) {
                onDropdownOpen();
            }

            if (!isMobile && trackingParams?.eventName) {
                trackFilterOpenForCategory({filterCategory: "Piętra", eventName: trackingParams.eventName});
            }
        }
    };

    // Sync value with initialValue when it changes (e.g., when navigating between offers)
    useEffect(() => {
        if (!isFirstRender.current) {
            setValue(initialValue ? initialValue : emptyValue);
        }
    }, [initialValue]);

    // Clear floor filter when house filter is changed otherwise we will show house filter for flat or opposite
    // Skip on first render to preserve initialValue
    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            prevOfferType.current = offerType;
            return;
        }

        // Only clear if offerType actually changed
        if (prevOfferType.current !== offerType) {
            setValue(emptyValue);

            if (handleClear) {
                handleClear();
            }
            prevOfferType.current = offerType;
        }
    }, [offerType]);

    return (
        <FakeSelectWithModal
            clearAriaLabel="Wyczyść filtr Piętra"
            rightDropdown={rightDropdown}
            aplaCss={aplaCss}
            onDropdownOpen={handlers.dropdownOpen}
            onDropdownClose={onDropdownClose}
            label={labelRenderer ? labelRenderer(value) : getFloorChoiceLabel(value, offerType)}
            isEmpty={value.length === 0}
            onClear={() => {
                if (trackingParams?.eventName && !isMobile) {
                    trackFilterRemove({
                        eventName: trackingParams.eventName,
                        filterType: "floor",
                        value,
                        offerType
                    });
                }
                handlers.clear();
            }}
            className={className}
        >
            {({close}) => (
                <>
                    <div data-testid={getFilterAreaTestId(offerType === OfferType.HOUSE ? "house_storeys" : "floor_choices")}>
                        <FloorChoicesSwitch
                            offerType={offerType}
                            name={name}
                            id={id}
                            value={value}
                            onChange={(_, value) => {
                                setValue(value);
                            }}
                        />
                    </div>

                    <FilterFooter
                        onCancel={() => {
                            if (trackingParams?.eventName && !isMobile) {
                                trackFilterClear({
                                    eventName: trackingParams.eventName,
                                    filterType: "floor",
                                    value,
                                    offerType
                                });
                            }
                            handlers.clear();
                            close();
                        }}
                        onSave={() => {
                            handlers.confirm(value);
                            close();
                        }}
                    />
                </>
            )}
        </FakeSelectWithModal>
    );
}
